import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { ArcAuthProviderWithRedirectHandling } from './ArcAuthProviderWithRedirectHandling';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import { AxiosInterceptor } from './service/instance';
import { ToastContainer } from 'react-toastify';
import HelmetComponent from './shared/components/helmet';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
    <AxiosInterceptor>
    <BrowserRouter>
    <ArcAuthProviderWithRedirectHandling>
    <ToastContainer />
      <HelmetComponent/>
    <App />
    </ArcAuthProviderWithRedirectHandling>
    </BrowserRouter>
    </AxiosInterceptor>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
